export const AB_TEST_GOLD_PRICE_INCREASE_FOR_NEW_USER_ID = 17;
export const AB_TEST_GOLD_PRICE_INCREASE_FOR_OLD_USER_ID = 18;
export const AB_TEST_PRICE_DECREASE_FOR_NEW_USER_ID = 23;
export const AB_TEST_EPOCH_PAYMENT_SYSTEM_ID = 22;
